import React from "react";
import { styled, media } from "../../../styles";
import { Content } from "../../../components";
import { ProjectCategories, ProjectCategoriesProps } from "./ProjectCategories";
import { ProjectSearch, ProjectSearchProps } from "./ProjectSearch";

export interface ProjectFilterProps
  extends ProjectCategoriesProps,
    ProjectSearchProps {}

export const ProjectFilter: React.SFC<ProjectFilterProps> = ({
  onChange,
  categories,
  selectedCategory,
  searchTerm,
  searchOpen,
  toggleSearch
}) => {
  return (
    <Content>
      <ProjectFilterContainer>
        <ProjectCategories
          categories={categories}
          selectedCategory={selectedCategory}
          searchTerm={searchTerm}
          searchOpen={searchOpen}
        />

        <ProjectSearch
          searchTerm={searchTerm}
          onChange={onChange}
          toggleSearch={toggleSearch}
          searchOpen={searchOpen}
        />
      </ProjectFilterContainer>
    </Content>
  );
};

const ProjectFilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: auto;
  margin: 0 -20px 0.5rem -20px;

  ${media.tablet} {
    margin: 1rem 0 0.5rem 0;
  }

  ${media.laptop} {
    margin: 0 0 0.5rem 0;
  }
`;
